/* eslint-disable quote-props */

import { ADMIN_ROLES } from "../../auth";

const detailRouteFour = () => ({
    "/:orgStructureFourId": {
        title: "",
        "/edit": {
            title: "Edit",
        }
    }
});

const detailRouteThree = () => ({
    "/:orgStructureThreeId": {
        title: "Organisation Structures Level 4",
        "/edit": {
            title: "Edit",
        },
        ...detailRouteFour(),
        "/create": {
            title: "Create OrgStructure"
        }
    }
});

const detailRouteTwo = () => ({
    "/:orgStructureTwoId": {
        title: "Organisation Structures Level 3",
        "/edit": {
            title: "Edit",
        },
        ...detailRouteThree(),
        "/create": {
            title: "Create OrgStructure"
        }
    }
});

const detailRouteOne = () => ({
    "/:orgStructureOneId": {
        title: "Organisation Structures Level 2",
        "/edit": {
            title: "Edit",
        },
        ...detailRouteTwo(),
        "/create": {
            title: "Create OrgStructure"
        }
    }
});

export const routes = {
    "/orgStructures": {
        title: "OrgStructures",
        ...detailRouteOne(),
        authorize: [ADMIN_ROLES.ADMINISTRATOR.name, ADMIN_ROLES.SENIOR_ADMINISTRATOR.name, ADMIN_ROLES.SYSTEM_ADMIN.name],
        "/edit": {
            title: "Edit",
        },
        "/create": {
            title: "Create OrgStructure"
        }
    }
};

export const childRoutes =
    (titleFunc: (state: any) => string) => {
        return {
            "/orgStructures": {
                title: (state: any) => titleFunc(state) + " Organisation Structures Level 1",
                ...detailRouteOne(),
                "/edit": {
                    title: "Edit",
                },
                "/create": {
                    title: "Create OrgStructure",
                }
            }
        };
    };
